<div
  [class.standard-padding-top]="standardPaddingTop"
  [class.full-page-height]="fullPageHeight"
>
  <ng-content></ng-content>
</div>
